var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSushiSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3268_50998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.78141 4.90625L43.3777 27.8456L35.0689 40.1281L1.47266 17.0081L9.78141 4.90625Z",
    fill: "url(#paint0_linear_3268_50998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3777 27.8437C40.4877 31.9981 30.7339 30.3725 21.522 23.87C12.1295 17.5481 7.07205 9.05872 9.78142 4.90435C12.6714 0.749975 22.4252 2.3756 31.637 8.8781C41.0295 15.0194 46.0871 23.6893 43.3777 27.8437Z",
    fill: "url(#paint1_linear_3268_50998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0688 39.9462C32.1788 44.1006 22.4251 42.475 13.2132 35.9725C4.00131 29.47 -1.23682 21.1612 1.65318 16.8262C4.54318 12.6718 14.2969 14.2975 23.5088 20.8C32.7207 27.3025 37.7782 35.7918 35.0688 39.9462Z",
    fill: "url(#paint2_linear_3268_50998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3776 27.8431L35.0689 40.1256C32.1789 44.2799 22.4251 42.4737 13.2133 36.1518C11.407 34.8874 9.78139 33.6231 8.15576 32.1781C9.42014 31.9974 11.0458 31.2749 12.6714 29.4687C15.5614 26.3981 17.0064 25.6756 18.2708 25.8562C19.5351 25.8562 20.9801 27.1206 23.3283 30.1912C25.6764 33.2618 28.9276 34.1649 30.9145 32.5393C31.0951 32.3587 31.2758 32.3587 31.4564 32.1781C33.082 30.9137 33.6239 30.3718 36.6945 24.5918C37.417 23.1468 39.9458 20.7987 43.3776 21.8824C44.2808 24.2306 44.2808 26.2174 43.3776 27.8431Z",
    fill: "#0E0F23"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.113 27.1229C39.5842 30.7354 30.7336 28.9292 22.2442 22.9685C13.5742 17.0079 8.51671 9.42167 11.0455 5.80917C13.5742 2.19667 22.4248 4.00292 30.9142 9.96354C39.4036 15.9242 44.4611 23.5104 42.113 27.1229ZM34.1655 21.7042C32.9011 23.5104 28.5661 22.6073 24.2311 19.7173C20.0767 16.8273 17.548 13.0342 18.8123 11.2279C20.0767 9.42167 24.4117 10.3248 28.7467 13.2148C32.9011 16.1048 35.4298 19.8979 34.1655 21.7042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05893 9.06013C9.05893 8.8795 8.8783 8.69888 8.69768 8.8795C8.51705 9.06013 8.33643 9.06013 8.33643 9.24075C8.51705 9.78263 8.69768 10.1439 8.69768 10.5051C8.69768 10.6858 8.8783 10.8664 9.05893 10.6858C9.23955 10.6858 9.42018 10.5051 9.23955 10.3245C9.23955 9.96325 9.23955 9.602 9.05893 9.06013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9618 11.9468C9.9618 11.7662 9.78117 11.5856 9.60055 11.7662C9.41992 11.9468 9.41992 11.9468 9.41992 12.1275C11.4068 16.6431 15.5612 21.52 20.9799 25.1325C21.1605 25.3131 21.3412 25.1325 21.5218 25.1325C21.7024 24.9518 21.5218 24.7712 21.5218 24.5906C15.9224 20.9781 11.9487 16.2818 9.9618 11.9468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8178 29.6484C31.6372 29.6484 31.4565 29.6484 31.4565 29.8291C31.4565 30.0097 31.4565 30.1903 31.6372 30.1903C32.179 30.3709 32.9015 30.5516 33.4434 30.7322C33.624 30.7322 33.8047 30.7322 33.8047 30.5516C33.8047 30.3709 33.8047 30.1903 33.624 30.1903C33.0822 30.0097 32.3597 29.8291 31.8178 29.6484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0688 30.3711C34.8881 30.3711 34.7075 30.5517 34.7075 30.7323C34.7075 30.913 34.8881 31.0936 35.0688 31.0936C36.5138 31.2742 38.1394 31.4548 39.4038 31.2742C39.5844 31.2742 39.765 31.0936 39.765 30.913C39.765 30.7323 39.5844 30.5517 39.4038 30.5517C37.9588 30.7323 36.5138 30.5517 35.0688 30.3711Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3268_50998",
    x1: 16.3637,
    y1: 1.6447,
    x2: 23.0263,
    y2: 24.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA52A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3268_50998",
    x1: 21.8504,
    y1: 0.0448148,
    x2: 28.5131,
    y2: 22.9233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA52A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3268_50998",
    x1: 10.894,
    y1: 3.23618,
    x2: 17.5567,
    y2: 26.1147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA52A0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3268_50998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.35,
    height: 43.35,
    fill: "white",
    transform: "translate(0.75 0.75)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSushiSwap);
export default __webpack_public_path__ + "static/media/sushiSwap.5ed6ae2b21c5d47f4aef5ee09bb4bb34.svg";
export { ForwardRef as ReactComponent };